<stages-dialog2 #dialog [classes]="classes">
	<div class="content">
		<router-outlet> </router-outlet>
	</div>
</stages-dialog2>
